import { render, staticRenderFns } from "./IssueItem.vue?vue&type=template&id=5e49f14c"
import script from "./IssueItem.vue?vue&type=script&lang=js"
export * from "./IssueItem.vue?vue&type=script&lang=js"
import style0 from "./IssueItem.vue?vue&type=style&index=0&id=5e49f14c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports